import { districtDeleteApi } from "../../api/district/districtDeleteApi"

type PayloadShape = Parameters<typeof districtDeleteApi>[0]

export async function districtDeleteService(payload: PayloadShape, token: string) {
	return await districtDeleteApi(payload, token)
}
